import { z } from "zod"

const StreamedTimestampSchema = z.iso.datetime({ offset: true })

export function parseStreamedTimestamp(value: unknown): string | undefined {
  const result = StreamedTimestampSchema.safeParse(value)
  return result.success ? result.data : undefined
}
